export enum CacheKey {
  User = 'user',
  Users = 'users',
  UserRegistry = 'user-registry',

  Admin = 'admin',
  AdminCustomerTree = 'admin_customer_tree',

  Customer = 'customer',
  CustomerActivityHistory = 'customer-activity-history',
  CustomerApplication = 'customer-application',
  CustomerChallenge = 'customer-challenge',
  CustomerCompliance = 'customer-compliance',
  CustomerContacts = 'customer-contacts',
  CustomerPriority = 'customer-priority',
  CustomerProduct = 'customer-product',
  CustomerProductAssignment = 'customer-product-assignment',
  CustomerSite = 'customer-site',
  SecureCustomerFile = 'secure-customer-file',
  LanTopology = 'lan-topology',
  WanTopology = 'wan-topology',

  Opportunity = 'opportunity',
  OpportunityActivityHistory = 'opportunity-activity-history',
  OpportunityArchitectures = 'opportunity-architecture',
  OpportunityChallenges = 'opportunity-challenges',
  OpportunityDeal = 'opportunity-deal',
  OpportunityOutcomes = 'opportunity-outcomes',
  OpportunityProduct = 'opportunity-product',
  OpportunityProductAssignment = 'opportunity-product-assignment',

  Pov = 'pov',
  PovOutcomes = 'pov-outcomes',
  PovPrereqs = 'pov-prereqs',
  PovTeam = 'pov-team',
  PovUseCases = 'pov-use-cases',

  ApprovalRequest = 'approval-request',
  ApprovalRequestDetails = 'approval-request-details',
  ApprovalRequestHistory = 'approval-request-history',
  ApprovalRequestItem = 'approval-request-item',
  Escalations = 'escalations',
  EscalationRequest = 'escalation-request',
  EscalationRequestHistory = 'escalation-request-history',
  EscalationApprovalRequest = 'escalation-approval-request',
  EscalationType = 'escalation-type',
  IncubationEscalations = 'incubation-opportunity-escalations',

  SalesforceCustomer = 'sf-customer',
  SalesforceCustomers = 'sf-customers',
  SalesforceCustomerTeam = 'sf-customer-team',
  SalesforceOpportunities = 'sf-opportunities',
  SalesforceQuery = 'sf-query',

  // --- AI RAG ---
  // AiRagModels = "ai-rag-models",
  // AiRagDocuments = "ai-rag-documents",
  // AiRagTemplates = "ai-rag-templates",
  // AiRagKnowledgeBases = "ai-rag-knowledge-bases",
  // AiRagChatSessions = "ai-rag-chat-sessions",
  // AiRagChatMessages = "ai-rag-chat-messages",
  // AiRagGenerationJobs = "ai-rag-generation-jobs",
  // AiRagGenerationJob = "ai-rag-generation-job",

  CustomTile = 'custom-tile',
  CustomTileCategory = 'custom-tile-category',
  CustomTileView = 'custom-tile-view',

  TileDataSource = 'tile-data-source',
  TileDataSourceEntity = 'tile-data-source-entity',
  TileDataSourceDetailed = 'tile-data-source-detailed',
  TileSourceCatalog = 'tile-source-catalog',

  // --- Dashboard layout (CustomTile placements) ---
  // DashboardPlacementLayout = 'dashboard-placement-layout',
  DashboardTileLink = 'dashboard-tile-link',
  DashboardPlacement = 'dashboard-placement',
  LeaderPage = 'leader-page',
  SystemBanner = 'system-banner',

  IntegrationModule = 'integration-module',
  Table = 'tables',
  // Trial = 'trial',
  Partner = 'partner',
  ServiceCreation = 'service-creation',
  ServiceCreationActivity = 'service-creation-activity',
  AllServiceCreation = 'all-service-creation',
  AllServiceCreationActivity = 'all-service-creation-activity',
  AllStage = 'all-stage',
  AllPartner = 'all-partner',
  AllPhase = 'all-phase',
  AllGeo = 'all-geo',
  AllMarketSegment = 'all-market-segment',
  AllAccountSegment = 'all-account-segment',
  AllAccountType = 'all-account-type',

  Product = 'product',
  CiscoProducts = "cisco-products",
  SafeCapability = 'safe-capability',
  ProductAppliance = 'product-appliance',
  ProductComponent = 'product-component',
  ProductComponentFeature = 'product-component-feature',
  ProductFeature = 'product-feature',
  ProductFeatureLicense = 'product-feature-license',
  ProductFeatureSuccessCriteria = "ProductFeatureSuccessCriteria",
  ProductIcon = 'product-icon',
  ProductLicense = 'product-license',
  ProductLicenseFeature = 'product-license-feature',
  ProductUseCase = 'product-use-case',
  ProductUseCaseFeature = 'product-use-case-feature',
  ProductVersion = 'product-version',
  Vendor = 'vendor',
  ProductSupportPaths = 'product-support-paths',

  UserProductExpertise = 'user-product-expertise',

  GtmSolution = 'gtm-solution',
  GtmArchitecture = 'gtm-architecture',
  GtmSolutionComponent = 'gtm-solution-component',
  GtmSolutionComponentFeature = 'gtm-solution-component-feature',
  GtmSolutionUseCase = 'gtm-solution-use-case',
  GtmSolutionUseCaseComponent = 'gtm-solution-use-case-component',
  GtmSolutionUseCaseComponentFeature = 'gtm-solution-use-case-component-feature',

  // Architecture page content (db/models/gtm_content.py). One key per table so the admin
  // panels and the portal pages invalidate the same records.
  GtmContentSection = 'go-to-market-content-section',
  GtmContentPoint = 'go-to-market-content-point',
  GtmContentListItem = 'go-to-market-content-list-item',
  GtmContentSource = 'go-to-market-content-source',
  GtmStat = 'go-to-market-stat',
  GtmRecognition = 'go-to-market-recognition',
  GtmFaq = 'go-to-market-faq',
  GtmLab = 'go-to-market-lab',
  GtmDemo = 'go-to-market-demo',
  GtmEvaluationStep = 'go-to-market-evaluation-step',
  GtmSalesStep = 'go-to-market-sales-step',
  GtmSalesStepAction = 'go-to-market-sales-step-action',
  GtmCompetitor = 'go-to-market-competitor',
  GtmCompetitorPoint = 'go-to-market-competitor-point',
  GtmComparisonVendor = 'go-to-market-comparison-vendor',
  GtmComparisonFeature = 'go-to-market-comparison-feature',
  GtmComparisonValue = 'go-to-market-comparison-value',

  Tag = 'tag',
  Resource = 'resource',

  // Join/through tables - not necessarily used as cache keys, but useful to have defined
  ProductToDeploymentMethod = 'product-to-deployment-method',
  ProductComponentToProductFeature = 'product-component-to-product-feature',
  ProductFeatureToLicense = 'product-feature-to-license',
  ProductFeatureVersion = 'product-feature-version',
  ProductUseCaseToProductFeature = 'product-use-case-to-product-feature',

  ProductToTag = 'product-to-tag',
  ProductComponentToTag = 'product-component-to-tag',
  ProductFeatureToTag = 'product-feature-to-tag',
  ProductUseCaseToTag = 'product-use-case-to-tag',

  ProductToResource = 'product-to-resource',
  ProductComponentToResource = 'product-component-to-resource',
  ProductFeatureToResource = 'product-feature-to-resource',
  ProductUseCaseToResource = 'product-use-case-to-resource',
  ProductVersionToResource = 'product-version-to-resource',
  VersionScopedResource = 'version-scoped-resource',

  GtmSolutionToTag = 'gtm-solution-to-tag',
  GtmSolutionComponentToTag = 'gtm-solution-component-to-tag',
  GtmSolutionUseCaseToTag = 'gtm-solution-use-case-to-tag',
  GtmSolutionUseCaseComponentToTag = 'gtm-solution-use-case-component-to-tag',
  GoToMarket = 'go-to-market',
  GoToMarketToTag = 'go-to-market-to-tag',
  JourneyMap = 'journey-map',
  JourneyMapToTag = 'journey-map-to-tag',
  GoToMarketToResource = 'go-to-market-to-resource',

  GtmSolutionToResource = 'gtm-solution-to-resource',
  GtmSolutionComponentToResource = 'gtm-solution-component-to-resource',
  GtmSolutionUseCaseToResource = 'gtm-solution-use-case-to-resource',
  GtmSolutionUseCaseComponentToResource = 'gtm-solution-use-case-component-to-resource',
  SecurityUseCase = 'security-use-case',
  SecurityUseCaseComponent = 'security-use-case-component',
  SecurityUseCaseToTag = 'security-use-case-to-tag',
  SecurityUseCaseComponentToTag = 'security-use-case-component-to-tag',
  SecurityUseCaseToResource = 'security-use-case-to-resource',
  SecurityUseCaseComponentToResource = 'security-use-case-component-to-resource',

  // Enablement - Moodle
  EventsByCourse = 'events-by-course',
  LeaderMoodleCompletionsByManager = 'LeaderMoodleCompletionsByManager',
  LeaderMoodleCompletionsByUser = 'LeaderMoodleCompletionsByUser',
  LeaderMoodleFeedbackByUser = 'LeaderMoodleFeedbackByUser',
  LeaderTttBulkStatus = 'LeaderTttBulkStatus',

  SnackableCourse = 'snackable-course',
  SnackableCourseExists = 'snackable-course-exists',
  SnackableCourseStatus = 'snackable-course-status',
  SnackableCourseGeneration = 'snackable-course-generation',
  SnackableCourseDeployment = 'snackable-course-deployment',
  EntityResourcesCheck = 'entity-resources-check',

  // --- Jira Release Notes ---
  JiraReleaseVersions = 'jira-release-versions',
  JiraReleaseNotes = 'jira-release-notes',

  // --- Documentation bundle (public/docs) ---
  Documentation = 'documentation',
  DocumentationPage = 'documentation-page',
  // --- dCloud ---
  DcloudLinkStatus = 'dcloud-link-status',
  DcloudSessions = 'dcloud-sessions',
  DcloudSession = 'dcloud-session',
  DcloudSessionHistory = 'dcloud-session-history',
  DcloudSchedulingOptions = 'dcloud-scheduling-options',
  DcloudCatalogSearch = 'dcloud-catalog-search',
  DcloudDemoCalendar = 'dcloud-demo-calendar',
  DcloudDemoContents = 'dcloud-demo-contents',

  // --- dCloud Topology Builder (TBv3) ---
  DcloudTopologyCapabilities = 'dcloud-topology-capabilities',
  DcloudTopologyCurrentUser = 'dcloud-topology-current-user',
  DcloudTopologyValidationLimits = 'dcloud-topology-validation-limits',
  DcloudTopologies = 'dcloud-topologies',
  DcloudTopology = 'dcloud-topology',
  DcloudTopologyOverview = 'dcloud-topology-overview',
  DcloudTopologyCollection = 'dcloud-topology-collection',
  DcloudTopologyDiagram = 'dcloud-topology-diagram',
  DcloudTopologyDocumentation = 'dcloud-topology-documentation',
  /** DC-scoped catalogs: which demos and which template topologies that data centre publishes. */
  DcloudTopologyDatacenterCatalog = 'dcloud-topology-datacenter-catalog',

  // --- dCloud lab controller ---
  // Operations, from toolbox_dcloud's lab app. Authoring reads go through the generic-CRUD
  // keys below so an edited step invalidates the same records the admin panels use.
  LabSessions = 'lab-sessions',
  LabSessionHealth = 'lab-session-health',
  LabRuns = 'lab-runs',
  LabRun = 'lab-run',
  LabRunTriggers = 'lab-run-triggers',
  LabAgents = 'lab-agents',
  LabPools = 'lab-pools',
  LabPool = 'lab-pool',
  LabAssignments = 'lab-assignments',
  LabAssistCases = 'lab-assist-cases',
  LabAssistCase = 'lab-assist-case',
  LabSweeps = 'lab-sweeps',
  LabInjections = 'lab-injections',
  LabInjection = 'lab-injection',
  LabInjectionResults = 'lab-injection-results',

  // --- Lab authoring (db/lab-*) ---
  /** The top-level authored unit: a composition of scenarios, published per data centre. */
  Lab = 'lab',
  /** One scenario attached to one lab, ordered. The tier that makes a scenario reusable. */
  LabScenarioLink = 'lab-scenario-link',
  /** How one device is reached in one publication. See `LabDeviceAddress`. */
  LabDeviceAddress = 'lab-device-address',
  LabScenario = 'lab-scenario',
  /** The device library. A device belongs to no scenario; attachment is `LabScenarioDeviceLink`. */
  LabDevice = 'lab-device',
  /** One device attached to one scenario. Invalidated with both ends, since both nest it. */
  LabScenarioDeviceLink = 'lab-scenario-device-link',
  LabScenarioStep = 'lab-scenario-step',
  LabSuccessCriterion = 'lab-success-criterion',
  LabScenarioTrigger = 'lab-scenario-trigger',
  LabReportSink = 'lab-report-sink',
  /** What kind of box an item is written for, and what a device claims to be. */
  LabDeviceType = 'lab-device-type',
  /** How a piece of work is carried out - rest_api, ssh, powershell, ansible, terraform. */
  LabExecutionMethod = 'lab-execution-method',
  /** Cisco products, for pointing a device type at one. Read-only here. */
  LabProducts = 'lab-products',
  /** The catalogue of configuration items, shared by every scenario that attaches one. */
  LabConfigurationItem = 'lab-configuration-item',
  /** One item attached to one scenario: its ordering, its option values, its provenance. */
  LabScenarioItem = 'lab-scenario-item',
  /** One scenario as published in one data centre. The scenario itself is DC-agnostic. */
  LabConfiguration = 'lab-configuration',
  /** One occasion a published lab is delivered on, single-session or a room. */
  LabEvent = 'lab-event',
  /** The data centres a configuration may be bound to (`db/dcloud-dc`). */
  LabDataCenters = 'lab-data-centers',

  // --- SAFE (db/safe/*) ---
  // Reference data only. The assessment itself is deliberately absent: the session endpoint is
  // stateless and the workshop lives in the client, so caching a "session" by key would hand
  // back a computed view of a workshop that has since moved on.
  SafeCollections = 'safe-collections',
  SafeCapabilityPriority = 'safe-capability-priority',
  SafeDiagnostics = 'safe-diagnostics',
  /** Architectures and their capabilities, for the Capability Selection filter. */
  SafeArchitectures = 'safe-architectures',

  // --- Customer workshops (db/workshop/*) ---
  // The engagement a SAFE assessment hangs off. Unlike the assessment, these *are* server state,
  // so they are cached normally. `CustomerWorkshopState` is the exception: it is read once to seed
  // the session and written by the session, so the hook that owns the assessment owns it too.
  CustomerWorkshops = 'customer-workshops',
  CustomerWorkshop = 'customer-workshop',
  CustomerWorkshopTypes = 'customer-workshop-types',
  CustomerWorkshopState = 'customer-workshop-state',
  /** The delivery checklist for one workshop: sections of its type, plus progress. */
  CustomerWorkshopSections = 'customer-workshop-sections',

  // --- Reusable assessments (db/assessment*) ---
  // A generalization of the workshop question set, decoupled from workshops: an Assessment is a
  // named, purpose-tagged form (workshop pre-work, feedback, a survey) built from Sections of
  // Questions, and filled in as a ResponseSet of Responses. One key per table so the builder
  // panels and the fill-in surface invalidate the same records.
  Assessments = 'assessments',
  Assessment = 'assessment',
  AssessmentSection = 'assessment-section',
  AssessmentQuestion = 'assessment-question',
  AssessmentResponseSet = 'assessment-response-set',
  AssessmentResponse = 'assessment-response',

  // --- Modular campaigns (db/campaign*) ---
  // A campaign is a hierarchical CampaignStep tree tracked two independent ways: per-SE enablement
  // (CampaignEnrollment) and customer-facing delivery (CampaignDelivery → targets → step statuses,
  // plus action items). One key per table so the resource and admin surfaces invalidate the same
  // records after a write.
  Campaigns = 'campaigns',
  Campaign = 'campaign',
  CampaignStep = 'campaign-step',
  CampaignEnrollment = 'campaign-enrollment',
  CampaignDelivery = 'campaign-delivery',
  CampaignDeliveryTarget = 'campaign-delivery-target',
  CampaignDeliveryStepStatus = 'campaign-delivery-step-status',
  CampaignActionItem = 'campaign-action-item',
  CampaignWorkshopMeeting = 'campaign-workshop-meeting',
  CampaignCustomerPersona = 'campaign-customer-persona',
  CampaignWorkshopTeamRole = 'campaign-workshop-team-role',
  CampaignReportSection = 'campaign-report-section',
  CampaignReportFigure = 'campaign-report-figure',
  CampaignOutcome = 'campaign-outcome',
  CampaignQuestion = 'campaign-question',
  CampaignCapability = 'campaign-capability',
  CampaignCustomerPersonaLink = 'campaign-customer-persona-link',
  CampaignWorkshopTeamRoleLink = 'campaign-workshop-team-role-link',
  CampaignOutcomeLink = 'campaign-outcome-link',
  CampaignQuestionLink = 'campaign-question-link',
  CampaignCapabilityLink = 'campaign-capability-link',
  CampaignContentBlock = 'campaign-content-block',
  CampaignAsset = 'campaign-asset',
  CampaignPhase = 'campaign-phase',
  CampaignPrompt = 'campaign-prompt',
  CampaignGroupAssignment = 'campaign-group-assignment',
  UserGroup = 'user-group',
  AiQuestion = 'ai-question',
  AzureUserSearch = 'azure-user-search',
  WorkshopMeetingOrder = 'workshop-meeting-order',
  CampaignEnablementReminderOrder = 'campaign-enablement-reminder-order',
}